import * as $ from 'jquery';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgSelectComponent } from '@ng-select/ng-select';
import { SelectionModel } from '@angular/cdk/collections';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { Component, AfterViewInit, ElementRef, OnInit, ViewChild, OnDestroy, HostListener } from '@angular/core';
const _ = require('lodash');

// Service Class
import { DashboardService } from './../../../../services/seed/dashboard.service';
import { GrowerOrderService } from './../../../../services/seed/growerOrder.service';
import { LoaderService } from './../../../../services/infrastructure/loader.service';
import { LocalStorageService } from './../../../../services/infrastructure/local-storage.service';
import { CommonService } from './../../../../services/common/common.service';

// Class
import { DashboardFilter } from './../../../../models/DashboardFilter';
import { GrowerOrderData } from './../../../../models/GrowerOrderData';
import { MasterConstants } from './../../../../common/constants/master-constants';
import { SeedReplantService } from '../../../../services/seed/seed-replant/seed-replant.service';
import { Subscription } from 'rxjs';
import { LolLoggerService } from '../../../../common/shared/lol-logger.service';
import { GrowerPdfGenerate } from '../../order/grower/grower-pdf-generate/grower-pdf-generate.component';
import { SeedReservationService } from '../../../../../../src/app/services/seed/seed-reservation.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../../../../common/components/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-seed-reservation-landing',
  templateUrl: './seed-reservation-landing.component.html',
  styleUrls: ['./seed-reservation-landing.component.scss']
})
export class SeedReservationLandingComponent implements OnInit, AfterViewInit, OnDestroy {

  //ViewChild
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('select') select: NgSelectComponent;
  @ViewChild('selectAccountHidden') selectHiddenAcc: ElementRef;
  @ViewChild('selectGrowerHidden') selectHiddengro: ElementRef;
  @ViewChild('growerPaginator', { read: MatPaginator }) growerPaginator: MatPaginator;
  @ViewChild('growerTable', { read: MatSort }) growerSort: MatSort;
  @ViewChild('pdfGenerator') pdfGenerator: GrowerPdfGenerate;

  //Any Variable
  headerYear: any;
  accountLoading: any;
  ddlSelectedAccountId: any;
  accountSearchData: any;
  accountNumber: any;
  accountNameCityState: any;
  accountBillingType: any;
  userMenuAccessList: any;
  growerLoading: any;
  growerOrderList: any;
  growerList: any;
  statusMessage: any = '';

  //Number Variables
  shipToAccount: number;
  accountDataCount = 0;
  selectedTabIndex = 0;
  searchCount = 0;
  selectedGrowerOrderId = 0;
  growerGMK: number;

  //Bool Variables
  isOpenFirst = false;
  isOpenSecond = false;
  readOnlyAccess = false;
  showHidebackDrop = false;

  //Obj Init
  subscription = new Subscription();
  dashboardFilter: DashboardFilter;
  growerOrderDataSource: MatTableDataSource<any>;
  selection = new SelectionModel<GrowerOrderData>(true, []);
  displayedColumns: string[] = ['orderID', 'growerName', 'accountName', 'shipToAccount', 'seller','unit', 'contextMenu'];

  //Values Assigned
  headerCompany = MasterConstants.US_COMPANYCODE;

  //String Variables
  emailAddress: string;

  isMobile = /Android|iPhone/i.test(window.navigator.userAgent);


  constructor(
    private dashboard: DashboardService,
    private router: Router,
    private loaderService: LoaderService,
    private growerOrderService: GrowerOrderService,
    private toastrService: ToastrService,
    private commonService: CommonService,
    private localStorageService: LocalStorageService,
    private seedReplantService: SeedReplantService,
    private seedReservationService: SeedReservationService,
    private matDialog: MatDialog) {
    this.dashboardFilter = new DashboardFilter();
    this.accountLoading = false;
  }


  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setHeight();
  }

  ngOnInit() {
    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.headerYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    }
    this.ddlSelectedAccountId = new Number();
    this.growerOrderDataSource = new MatTableDataSource([]);
    this.growerOrderDataSource.paginator = this.paginator;
    this.growerOrderDataSource.sort = this.sort;
    if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
      const data = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      if (data !== null && data !== undefined && data.resultData.length > 0) {
        this.userMenuAccessList = data.resultData.find(x => x.userIdCompanyCode == MasterConstants.US_COMPANYCODE).userMenuAccessList;
        if (this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.SEED_RESERVATION)) {
          this.readOnlyAccess = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.SEED_RESERVATION, MasterConstants.USER_ACCESS.READ_ONLY, this.userMenuAccessList);
          if (this.headerYear && this.headerCompany) {
            this.getAccountDropDownData();
            this.getLandingReservationData(0, 0);
          }
        }
      }
    }
  }

  ngAfterViewInit() {
    this.growerOrderDataSource.paginator = this.growerPaginator;
    this.growerOrderDataSource.sort = this.growerSort;
    this.setHeight();
  }

  tabChanged = (tabChangeEvent: MatTabChangeEvent): void => {
    if (tabChangeEvent) {
      this.selectedTabIndex = +(tabChangeEvent.index);
    }
    this.setHeight();
  };

  setHeight() {
    if (window.innerWidth > 767) {
      const templateHeight = window.innerHeight - $('.TopSec').outerHeight() - $('.js-searchWrapper').outerHeight() - $('.order-top-sec').outerHeight() - 187;
      $('.growertableContainer').css('max-height', templateHeight + 'px');
    }
  }

  setFocusOut() {
    this.selectHiddenAcc.nativeElement.focus();
    this.selectHiddengro.nativeElement.focus();
  }

  onOpen() {
    this.showHidebackDrop = true;
    this.dashboard.isBackDropVisible.next(true);
  }

  onClose() {
    this.showHidebackDrop = false;
    this.dashboard.isBackDropVisible.next(false);
  }

  topOpen() {
    this.isOpenFirst = true;
  }

  middleOpen() {
    this.isOpenSecond = true;
  }

  topClose() {
    this.isOpenFirst = false;
  }

  middleClose() {
    this.isOpenSecond = false;
  }

  navigateToSingleAccount(obj: any, isUpdate: boolean) {
    if (obj) {
      if (this.ddlSelectedAccountId == null || this.ddlSelectedAccountId == '') {
        this.ddlSelectedAccountId = 0;
      }
      this.loaderService.setLoaderStatus(true);
      this.seedReservationService.setseedReservationId(obj.orderID, isUpdate);
      this.loaderService.setLoaderStatus(false);
      this.router.navigate(['/seed-reservation/seed-reservation-confirmation']);
    }
  }

  createNewOrder() {
    this.router.navigate(['/seed-reservation/seed-reservation-create']);
  }

  navigateToReconcileReservation(element: any) {
    if (element) {
      this.seedReservationService.setseedReservationId(element.growerOrderId, true);
      this.router.navigate(['/seed-reservation/seed-reservation-reconcile-create']);
    }
  }
  accountSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.accountName.toLocaleLowerCase().indexOf(term) > -1
      || item.accountNumber.toString().indexOf(term) > -1
      || item.address1.toLocaleLowerCase().indexOf(term) > -1
      || item.city.toLocaleLowerCase().indexOf(term) > -1
      || item.state.toLocaleLowerCase().indexOf(term) > -1
      || item.zipCode.toLocaleLowerCase().indexOf(term) > -1;
  }

  accountSearchOnClose($event) {
    if ($event != undefined) {
      this.growerOrderService.AccountChange({
        accountName: $event.accountName,
        accountNumber: $event.accountNumber,
        accountType: $event.accountType,
        billingAddressType: $event.billingAddressType,
        address1: $event.address1,
        address2: $event.address2,
        emailAddress: $event.emailAddress,
        city: $event.city,
        state: $event.state,
        zipCode: $event.zipCode,
        isAccountRIB: false
      });
      this.dashboardFilter.shipToAccount = $event.accountNumber;
      this.dashboardFilter.gMk = 0;
      this.accountBillingType = $event.billingAddressType;
      this.shipToAccount = $event.accountNumber;
      this.emailAddress = $event.emailAddress;
    }
    else {
      this.dashboardFilter.shipToAccount = 0;
      this.growerList = null;
      this.growerGMK = null;
    }
    this.getGrowerListByAccount();
    this.getLandingReservationData(this.dashboardFilter.shipToAccount, 0);
    this.growerOrderService.SetAccountState(true);
    setTimeout(() => this.setFocusOut(), 500);
  }

  accountSearchOnClear($event) {
    if (this.ddlSelectedAccountId == null || this.ddlSelectedAccountId == '' || this.ddlSelectedAccountId == 0) {
      this.accountBillingType = '';
    }
    this.dashboardFilter.shipToAccount = 0;
    this.dashboardFilter.gMk = 0;
    this.growerList = null;
    this.growerGMK = null;
    this.getLandingReservationData(0, 0);
    this.growerOrderService.AccountChange(null);
  }

  isAllGrowerOrderSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.growerOrderDataSource.data.length;
    return numSelected === numRows;
  }

  masterToggleGrower() {
    this.isAllGrowerOrderSelected() ?
      this.selection.clear() :
      this.growerOrderDataSource.data.forEach(row => this.selection.select(row));
  }

  getLandingReservationData(shipToAccount, GMK) {
    // Build the filter object to match your backend's SeedReservationLandingFilterVM
    const filter = {
      shipToAccount: shipToAccount,
      gmk: GMK
    };

    this.loaderService.setLoaderStatus(true);

    this.subscription.add(
      this.seedReservationService.getLandingData(filter).subscribe(
        result => {
          this.growerOrderList = result;
          this.growerOrderList.forEach(grower => {
            grower.growerName = (grower.growerName == null || grower.growerName == ''
              ? (grower.firstName != null && grower.firstName != '' ? grower.firstName : '') +
              (grower.middleName != null && grower.middleName != '' ? ' ' + grower.middleName : '') +
              (grower.lastName != null && grower.lastName != '' ? ' ' + grower.lastName : '')
              : grower.growerName);
          });
          this.growerOrderDataSource = new MatTableDataSource(this.growerOrderList);
          setTimeout(() => {
            this.growerOrderDataSource.paginator = this.growerPaginator;
            this.growerOrderDataSource.sort = this.growerSort;
          });
          if (this.dashboardFilter.shipToAccount == 0) {
            this.ddlSelectedAccountId = new Number();
          }
          this.loaderService.setLoaderStatus(false);
        },
        error => {
          LolLoggerService.error(error);
          this.loaderService.setLoaderStatus(false);
        }
      )
    );
  }

  getAccountDropDownData() {
    this.accountLoading = true;
    this.dashboardFilter.cropYear = this.headerYear;
    this.subscription.add(this.seedReservationService.getAccountList().subscribe(result => {
      this.accountSearchData = result;
      this.accountDataCount = this.accountSearchData.length;
      this.accountLoading = false;
    }, error => LolLoggerService.error(error)));
  }

  getGrowerListByAccount() {
    this.growerLoading = true;
    this.growerList = null;
    this.growerGMK = null;
    this.dashboardFilter.cropYear = this.headerYear;
    this.dashboardFilter.shipToAccount = this.shipToAccount;
    const growerFilters = { 'GrowerGLN': '', 'GrowerName': '' };
    this.subscription.add(this.seedReplantService.getGrowerListByFilter(this.dashboardFilter, growerFilters).subscribe(result => {
      this.growerList = result;
      this.searchCount = this.growerList.length;
      this.growerList.forEach(grower => {
        grower.businessName = (grower.businessName == null || grower.businessName == '' ?
          (grower.firstName != null && grower.firstName != '' ? grower.firstName : '') +
          (grower.middleName != null && grower.middleName != '' ? ' ' + grower.middleName : '') +
          (grower.lastName != null && grower.lastName != '' ? ' ' + grower.lastName : '')
          : grower.businessName);
        grower.EmailTo = this.emailAddress;
      });
      this.growerLoading = false;
      this.loaderService.setLoaderStatus(false);
    }, error => {
      this.growerLoading = false;
      this.loaderService.setLoaderStatus(false);
    }));
  }

  growerSearchFn(term: string, item: any) {
    if (term) {
      term = term.toLocaleLowerCase();
    }
    return (item.businessName == null ? false : item.businessName.toLocaleLowerCase().indexOf(term) > -1)
      || (item.firstName == null ? false : item.firstName.toLocaleLowerCase().indexOf(term) > -1)
      || (item.lastName == null ? false : item.lastName.toLocaleLowerCase().indexOf(term) > -1)
      || (item.growerGLN == null ? false : item.growerGLN.toString().indexOf(term) > -1)
      || (item.gmk == null ? false : item.gmk.toString().indexOf(term) > -1)
      || (item.address1 == null ? false : item.address1.toLocaleLowerCase().indexOf(term) > -1)
      || (item.city == null ? false : item.city.toLocaleLowerCase().indexOf(term) > -1)
      || (item.state == null ? false : item.state.toLocaleLowerCase().indexOf(term) > -1)
      || (item.zip == null ? false : item.zip.toLocaleLowerCase().indexOf(term) > -1)
      || (item.primaryPhoneNumber == null ? false : item.primaryPhoneNumber.toLocaleLowerCase().indexOf(term) > -1);
  }

  search($event) {
    let list: any;
    list = _.filter(this.growerList, item => item.businessName == null ? false : item.businessName.toLocaleLowerCase().indexOf($event) > -1
      || (item.firstName == null ? false : item.firstName.toLocaleLowerCase().indexOf($event) > -1)
      || (item.lastName == null ? false : item.lastName.toLocaleLowerCase().indexOf($event) > -1)
      || (item.growerGLN == null ? false : item.growerGLN.toString().indexOf($event) > -1)
      || (item.gmk == null ? false : item.gmk.toString().indexOf($event) > -1)
      || (item.address1 == null ? false : item.address1.toLocaleLowerCase().indexOf($event) > -1)
      || (item.city == null ? false : item.city.toLocaleLowerCase().indexOf($event) > -1)
      || (item.state == null ? false : item.state.toLocaleLowerCase().indexOf($event) > -1)
      || (item.zip == null ? false : item.zip.toLocaleLowerCase().indexOf($event) > -1)
      || (item.primaryPhoneNumber == null ? false : item.primaryPhoneNumber.toLocaleLowerCase().indexOf($event) > -1));
    this.searchCount = list.length;
  }

  onGrowerSelection($event) {
    if ($event != undefined) {
      this.growerOrderService.GrowerChange({
        growerName: $event.growerName,
        address1: $event.address1,
        city: $event.city,
        state: $event.state,
        zip: $event.zip,
        gmk: $event.gmk,
        gln: $event.gln
      });
      this.dashboardFilter.shipToAccount = this.shipToAccount;
      this.dashboardFilter.gMk = $event.gmk;
    }
    else {
      this.dashboardFilter.gMk = 0;
      this.growerOrderService.GrowerChange(null);
    }
    this.getLandingReservationData(this.shipToAccount, this.dashboardFilter.gMk);
    setTimeout(() => this.setFocusOut(), 500);
  }

  setSelectedGrowerOrderId(id) {
    this.selectedGrowerOrderId = id;
  }

  generatePdf() {
    this.pdfGenerator.generatePdf();
  }

  exportToExcel() {
    this.loaderService.setLoaderStatus(true); // Show loader immediately
    const filter = {
      ShipToAccount: this.dashboardFilter.shipToAccount,
      GMK: this.dashboardFilter.gMk
    };

    this.subscription.add(this.seedReservationService
      .exportToExcel(filter)
      .subscribe(
        (result) => {
          if (result) {

            this.seedReservationService.base64toFile(result.base64, result.mimeType, result.fileName);
            this.loaderService.setLoaderStatus(false);
          }
          else {
            this.loaderService.setLoaderStatus(false);
            this.toastrService.error("An error occurred during export.");
          }
        },
        (error) => this.toastrService.error("An error occurred during export.")
      ));
  }

  exportReconciliationAtAccountLevel() {
    this.exportReconciliation('Account');
  }

  exportReconciliationAtParentAccountLevel() {
    this.exportReconciliation('ParentAccount');
  }

  private exportReconciliation(reconciliationLevel: string) {
    this.loaderService.setLoaderStatus(true); // Show loader immediately
    const filter = {
      ShipToAccount: this.dashboardFilter.shipToAccount,
      GMK: this.dashboardFilter.gMk,
      ReconciliationLevel: reconciliationLevel
    };

    this.subscription.add(this.seedReservationService
      .exportReconciliationToExcel(filter)
      .subscribe(
        (result) => {
          if (result) {
            this.seedReservationService.base64toFile(result.base64, result.mimeType, result.fileName);
            this.loaderService.setLoaderStatus(false);
          }
          else {
            this.loaderService.setLoaderStatus(false);
            this.toastrService.error("An error occurred during export.");
          }
        },
        (error) => this.toastrService.error("An error occurred during export.")
      ));
  }

  deleteReservation(reservationId) {
    const dialogRef = this.matDialog.open(ConfirmDialogComponent, {
      disableClose: true,
      width: '400px',
      data: { title: 'Delete Reservation', message: 'Do you want to delete this reservation?', labelYes: 'Yes', labelNo: 'No', dialogType: 'confirm' }
    });

    this.subscription.add(dialogRef.afterClosed().subscribe(result => {
      // If user selected Yes
      if (result == true) {
        this.loaderService.setLoaderStatus(true);
        this.subscription.add(this.seedReservationService.deleteReservation(reservationId).subscribe((result: any) => {
          if (result) {
            this.growerOrderList = this.growerOrderList.filter(x => x.orderID != reservationId);
            this.growerOrderDataSource = new MatTableDataSource(this.growerOrderList);
            setTimeout(() => {
              this.growerOrderDataSource.paginator = this.growerPaginator;
              this.growerOrderDataSource.sort = this.growerSort;
            });
            this.loaderService.setLoaderStatus(false);
            this.toastrService.success('The reservation is successfully deleted.');
          } else {
            this.loaderService.setLoaderStatus(false);
            this.toastrService.error('There is some issue while delete.');
          }
        }, error => { this.loaderService.setLoaderStatus(false); }));
      }
    }));
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
